// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1dPtN","label":"Section_label__EB46W","contentWrap":"Section_contentWrap__jFM63","footer":"Section_footer__gVx5f","footerInner":"Section_footerInner__38Qu1"};